import * as Yup from 'yup';

export const addEmployeeValidationSchema = Yup.object().shape({
  fullname: Yup.string().required('employee.validationErrors.fullnameRequired'),
  email: Yup.string()
    .email('employee.validationErrors.emailInvalid')
    .required('employee.validationErrors.emailRequired'),
  password: Yup.string()
    .required('employee.validationErrors.passwordRequired')
    .matches(
      // eslint-disable-next-line no-useless-escape
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,
      'employee.validationErrors.passwordRule'
    ),
  researchFieldIds: Yup.array(),
  roleIds: Yup.array().min(1, 'employee.validationErrors.roleIdsRequired'),
  organizationId: Yup.string().required('employee.validationErrors.organizationRequired'),
  organizationEnglishName: Yup.string().nullable(),
  specificOrganizationName: Yup.string()
    .nullable()
    .when('organizationEnglishName', {
      is: 'Other',
      then: Yup.string().required('formControl.validation.required'),
    }),
  gender: Yup.string(),
  phone: Yup.string(),
  academicRank: Yup.string().nullable(),
  academicRankYear: Yup.number().nullable(),
  academicDegree: Yup.string().required('employee.validationErrors.academicDegreeRequired'),
  academicDegreeYear: Yup.number().nullable(),
});

export const updateEmployeeValidationSchema = Yup.object().shape({
  fullname: Yup.string().required('employee.validationErrors.fullnameRequired'),
  researchFieldIds: Yup.array(),
  roleIds: Yup.array().min(1, 'employee.validationErrors.roleIdsRequired'),
  organizationId: Yup.string().required('employee.validationErrors.organizationRequired'),
  organizationEnglishName: Yup.string().nullable(),
  specificOrganizationName: Yup.string()
    .nullable()
    .when('organizationEnglishName', {
      is: 'Other',
      then: Yup.string().required('formControl.validation.required'),
    }),
  status: Yup.string().required('employee.validationErrors.statusRequired'),
  gender: Yup.string(),
  phone: Yup.string(),
  academicRank: Yup.string().nullable(),
  academicRankYear: Yup.number().nullable(),
  academicDegree: Yup.string().required('employee.validationErrors.academicDegreeRequired'),
  academicDegreeYear: Yup.number().nullable(),
});
